import {Observable} from "rxjs";
import {
  AgentCashOfferWrapper,
  AgentContactProperty,
  AgentSignature,
  AVMMultiHistoryInfo,
  ChangelogEventType,
  CMAFromDashboardRequest,
  CompLite,
  ContactAgentFromDashboardRequest,
  DashboardHomeFactsUpdateRequest,
  DashboardModuleButtonAction,
  FelloConnectedAppType,
  FelloMultiAvmResponse,
  HomeEstimates,
  HomeValueFromDashboardRequest,
  LeadRequestFromDashboard,
  MortgageBulkData,
  MortgageBulkDataParams,
  PropertyHomeEquityResponse,
  PublicContactDashboard,
  PublicDashboardContact,
  PublicDashboardProperty,
  SellingOptionsResponse,
  TrackTPModuleClickRequest
} from "fello-model";

export abstract class AbstractDashboardService {
  abstract propertyAndContact$: Observable<PublicContactDashboard>;
  abstract property$: Observable<PublicDashboardProperty>;
  abstract isPropertyLoading: Observable<boolean>;
  abstract contact$: Observable<PublicDashboardContact>;
  abstract offer$: Observable<AgentCashOfferWrapper>;
  abstract agentSignature$: Observable<AgentSignature | null>;
  abstract comps$: Observable<CompLite[]>;
  abstract homeEstimate$: Observable<HomeEstimates>;
  abstract felloMultiAvmResponse$: Observable<FelloMultiAvmResponse>;
  abstract sellingOptionsResponse$: Observable<SellingOptionsResponse>;
  abstract multiAvmHistory$: Observable<AVMMultiHistoryInfo>;
  abstract homeEquity$: Observable<PropertyHomeEquityResponse>;
  abstract isDummyDashboard$: Observable<boolean>;

  abstract refreshProperty(): void;

  abstract updateBuyingWithSelling(buyingArea: string, buyingPriceLow: number, buyingPriceHigh: number): Observable<void>;

  abstract updateHomeFacts(facts: DashboardHomeFactsUpdateRequest): Observable<void>;

  abstract trackTPModuleClick(trackRequest: TrackTPModuleClickRequest): Observable<{_id: string}>;

  abstract trackDashboardView(): Observable<void>;

  abstract trackDashboardClick(text: string, moduleId: string): Observable<void>;

  abstract submitContactAgentForm(
    eventType: ChangelogEventType,
    contactAgentFromDashboardRequest: ContactAgentFromDashboardRequest
  ): Observable<void>;

  abstract submitRequestCMAForm(cmaRequest: CMAFromDashboardRequest): Observable<void>;

  abstract performCTAAction(action: DashboardModuleButtonAction): Observable<{url: string}>;

  abstract submitCTAPopupLeadForm(
    action: DashboardModuleButtonAction,
    data: LeadRequestFromDashboard,
    connectedAppType?: FelloConnectedAppType
  ): Observable<void>;

  abstract addNewAddress(
    addAddressAction?: (
      propertyId: string,
      rawAddress: string,
      hvRequestFromDashboard: HomeValueFromDashboardRequest
    ) => Observable<AgentContactProperty>
  ): Observable<boolean>;

  abstract unClaimClaimedProperty(property: PublicDashboardProperty): Observable<boolean>;

  abstract unClaimUnClaimedProperty(property: PublicDashboardProperty): Observable<boolean>;

  abstract getMortgageBulkData(params: MortgageBulkDataParams): Observable<MortgageBulkData>;
}
